<template>
  <div class="single-income">
    <div class="list">
      <el-row type="flex" class="payment-type">
        <el-col :span="18" class="payment-detail">
          <i class="ico ico-paypal-40"></i>
          <div class="">
            <p>Paypal</p>
            {{paypal.card_number}}
          </div>
        </el-col>
        <el-col :span="6" class="text-right">
          <WithdrawType v-on:success="getWithdrawList" :item="paypal"><i class="ico ico-edit" @click="edit(paypal)"></i></WithdrawType>
          <i class="ico ico-del" @click="del(paypal)"></i>
        </el-col>
      </el-row>
      <el-row type="flex" class="payment-type">
        <el-col :span="18" class="payment-detail">
          <i class="ico ico-alipay-40"></i>
          <div class="">
            <p>支付宝</p>
            {{alipay.card_number}}
          </div>
        </el-col>
        </el-col>
        <el-col :span="6" class="text-right">
          <WithdrawType v-on:success="getWithdrawList" :item="alipay"><i class="ico ico-edit" @click="edit(alipay)"></i></WithdrawType>
          <i class="ico ico-del" @click="del(alipay)"></i>
        </el-col>
      </el-row>
      <el-row type="flex" class="payment-type" v-for="(item,index) in list" :key="index">
        <el-col :span="18" class="payment-detail">
          <i class="ico ico-alipay-40"></i>
          <div class="">
            <p>{{item.bank_name}}</p>
            {{item.card_number}}
          </div>
        </el-col>
        </el-col>
        <el-col :span="6" class="text-right">
          <AddBankCard v-on:success="getWithdrawList" :item="item"><i class="ico ico-edit" @click="edit(item)"></i></AddBankCard>
          <i class="ico ico-del" @click="del(item)"></i>
        </el-col>
      </el-row>
      <p class="add-card">
        <AddBankCard v-on:success="getWithdrawList" :item="{type:1}"><span><i class="ico ico-add"></i> 添加银行卡</span></AddBankCard>
      </p>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import WithdrawType from './components/WithdrawType'
import AddBankCard from './components/AddBankCard'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  components: {
    WithdrawType: WithdrawType,
    AddBankCard: AddBankCard
  },
  computed: {
  },
  created () {
    this.getWithdrawList()
  },
  data () {
    return {
      list: null,
      alipay: {
        type: 3
      },
      paypal: {
        type: 4
      }
    }
  },
  methods: {
    async getWithdrawList () {
      let res = await api.getWithdrawList(this)
      res = res.body.result || []
      this.list = []
      this.alipay = {
        type: 3,
        bank_name: '支付宝'
      },
      this.paypal = {
        type: 4,
        bank_name: 'paypal'
      }
      _.each(res, item => {
        if (item.type == 1) {
          this.list.push(item)
        } else if (item.type == 3) {
          this.alipay = item
        } else if (item.type == 4) {
          this.paypal = item
        }
      })
    },
    async edit(item) {

    },
    async del(item) {
      let res = await api.post(this, {
        path: 'single.php',
        api: 'delete_withdraw_type',
        data: {
          withdraw_type_id: item.id
        },
        loading: 'loading'
      })
      this.getWithdrawList()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .single-income {
    padding: 0 35px 60px;
    .list {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }
    }

    .payment-type {

      .payment-detail {
        i {
          float: left;
        }
        div {
          margin-left: 60px;
          color: #666;

          p {
            font-size: 16px;
            color: #333;
            margin-bottom: 5px;
          }
        }
      }

      .ico-del {
        margin-left: 30px;
      }

      .ico-edit,
      .ico-del {
        margin-top: 13px;
        cursor: pointer;
      }
    }



    .add-card {
      color: #666;
      line-height: 22px;
      margin-top: 30px;

      span {
        cursor: pointer;
      }
    }

  }
@media screen and (max-width:1024px){
  .single-income{
    padding: 0 0px 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/GetWithdraw.vue